import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCustomPageTitle } from '../../hooks/usePageTitle';
import { QuickEstimateView } from '../../components/estimation/quick/QuickEstimateView';
import { DetailedEstimateView } from '../../components/estimation/detailed/DetailedEstimateView';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import ErrorMessage from '../../components/ui/ErrorMessage';
import { versionDetector } from '../../services/estimationVersionDetector';
import { legacyAdapter } from '../../services/legacyEstimationAdapter';

const ViewEstimate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  useCustomPageTitle('Consultation d\'estimation');
  const [estimate, setEstimate] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const savedEstimate = localStorage.getItem('viewEstimate');
    if (!savedEstimate) {
      setError('Estimation non trouvée');
      setLoading(false);
      return;
    }
    try {
      let parsedEstimate = JSON.parse(savedEstimate);

      console.log('📊 ViewEstimate - Données reçues:', {
        hasType: !!parsedEstimate.type,
        type: parsedEstimate.type,
        hasPropertyType: !!parsedEstimate.propertyType,
        hasArea: !!parsedEstimate.area,
        hasPriceRange: !!parsedEstimate.priceRange,
        priceRange: parsedEstimate.priceRange
      });

      const estimationType = parsedEstimate.type ||
        (parsedEstimate.propertyType && parsedEstimate.area && parsedEstimate.renovationLevel ? 'quick' : 'detailed');

      if (estimationType === 'detailed' && versionDetector.isLegacyFormat(parsedEstimate)) {
        console.log('🔄 Legacy detailed estimation detected, adapting...');
        parsedEstimate = legacyAdapter.adaptLegacyEstimation(parsedEstimate);
        console.log('✅ Detailed estimation adapted to current format');
      } else if (estimationType === 'quick') {
        console.log('✅ Quick estimation - using data as-is');
        if (parsedEstimate.priceRange?.sections) {
          delete parsedEstimate.priceRange.sections;
        }
      }

      setEstimate(parsedEstimate);
    } catch (err) {
      console.error('❌ Error loading estimate:', err);
      setError('Erreur lors du chargement de l\'estimation');
    } finally {
      setLoading(false);
    }
  }, [id]);

  const handleBack = () => {
    navigate('/dashboard');
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} />;
  if (!estimate) return null;

  const estimationType = estimate.type ||
    (estimate.propertyType && estimate.area && estimate.renovationLevel ? 'quick' : 'detailed');

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {estimationType === 'detailed' ? (
        <DetailedEstimateView data={estimate} onBack={handleBack} estimateId={id} />
      ) : (
        <QuickEstimateView data={estimate} onBack={handleBack} />
      )}
    </div>
  );
};

export default ViewEstimate;